import React from 'react';
import ReactDOM from 'react-dom';
import PermissionCapabilities from './permission-capabilities';
import NotificationPreferences from './notification-preferences';
import LogAccessSummary from './log-access-summary';
import MemberGroupList from './member-group-list';

class NewMember extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: [],
      readOnly: false,
      canAccessAllGroups: true,
      manageMembers: true,
      manageBilling: true,
      hasLogAccess: true,
      purgeLogs: true,
      receiveBillingEmails: true,
      receiveUsageEmails: true,
      groupIds: []
    }

    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onLogAccessSelectChange = this.onLogAccessSelectChange.bind(this);
    this.onLogAccessChange = this.onLogAccessChange.bind(this);
    this.onBoolSelectChange = this.onBoolSelectChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      groups: PT.customerGroups
    });
  }

  // general checkbox handler, when the only thing that needs
  // to happen is switching the boolean state
  onCheckboxChange(key) {
    return (e) => {
      this.setState({
        [key]: e.target.checked
      });
    };
  };

  // responsible for handling the "Full" vs "Read-Only" log
  // access state; if "Read-Only", we need to make sure the
  // member cannot purge logs
  onLogAccessSelectChange(e) {
    let readOnly = (e.target.value == '1');

    if (readOnly) {
      this.setState({
        readOnly: true,
        purgeLogs: false
      });
    } else {
      this.setState({
        readOnly: false
      });
    }
  };

  // responsible for toggling views for log access
  onLogAccessChange(e) {
    let isChecked = e.target.checked;

    if (isChecked) {
      this.setState({
        hasLogAccess: true
      });
    } else {
      this.setState({
        hasLogAccess: false,
        canAccessAllGroups: false,
        purgeLogs: false,
        groupIds: []
      });
    }
  };

  // general select handler, when the only thing that needs
  // to happen is setting the state; this specific handler is
  // for select's that have 1/0 (boolean) state values
  onBoolSelectChange(key) {
    return (e) => {
      this.setState({
        [key]: (e.target.value == '1')
      });
    };
  };

  render() {
    return (
      <div className="edit-mode">
        <div className="list-box sectioned permissions-box mod-editable">
          <div className="grid flex">
            <PermissionCapabilities
              isEditable={true}
              isVisible={true}
              manageMembers={this.state.manageMembers}
              manageBilling={this.state.manageBilling}
              hasLogAccess={this.state.hasLogAccess}
              onCheckboxChange={this.onCheckboxChange}
              onLogAccessChange={this.onLogAccessChange}
            />

            <NotificationPreferences
              isEditable={true}
              receiveUsageEmails={this.state.receiveUsageEmails}
              receiveBillingEmails={this.state.receiveBillingEmails}
              editableNotifications={true}
              paysSomeoneElse={false}
              onCheckboxChange={this.onCheckboxChange}
            />
          </div>

          <LogAccessSummary
            isEditable={true}
            isVisible={this.state.hasLogAccess}
            manageMembers={this.state.manageMembers}
            readOnly={this.state.readOnly}
            canAccessAllGroups={this.state.canAccessAllGroups}
            purgeLogs={this.state.purgeLogs}
            onCheckboxChange={this.onCheckboxChange}
            onBoolSelectChange={this.onBoolSelectChange}
            onLogAccessSelectChange={this.onLogAccessSelectChange}
          />

          <MemberGroupList
            isEditable={true}
            isVisible={this.state.hasLogAccess && !this.state.manageMembers}
            canAccessAllGroups={this.state.manageMembers || this.state.canAccessAllGroups}
            groups={this.state.groups}
            groupIds={this.state.groupIds}
            onGroupCheckboxChange={() => {}}
          />
        </div>
      </div>
    );
  }
};

$(function() {
  var el = document.getElementById('new-member-ui');
  if (el) ReactDOM.render(<NewMember />, el);
});

export default NewMember;